import React, { forwardRef } from 'react'
import { ContainerProps } from './Container.types'
import { StyledContainer } from './Container.styles'

const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ children, ...props }, ref) => {
    return (
      <StyledContainer ref={ref} {...props}>
        {children}
      </StyledContainer>
    )
  }
)

Container.displayName = 'Container'

export default Container
